module.exports = __webpack_public_path__ + "img/071-serbia.05d3c228.svg";